<template>
  <div>
    <div class="main-wrapper">
      <sidebar-component classMenu="Rute"></sidebar-component>

      <div class="page-wrapper">
        <navbar-component></navbar-component>

        <div class="page-content">
          <div class="d-flex justify-content-between align-items-center flex-wrap grid-margin">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <margin-estimasi-form title="Add Margin Estimasi" submit-label="Submit" :value="form" :loading="isLoading"
                :errors="errors" mode="add" @submit="submitData" @cancel="backForm" />
            </div>
          </div>
        </div>

        <footer-component></footer-component>
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import MarginEstimasiForm from "@/components/master/margin_estimasi/MarginEstimasiForm.vue";

export default {
  name: "MarginEstimasiAdd",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "margin-estimasi-form": MarginEstimasiForm,
  },
  data() {
    return {
      isLoading: false,
      errors: {},
      form: {},
    };
  },
  methods: {
    submitData(payload) {
      this.isLoading = true;
      this.errors = {};

      const baseURI = this.$settings.endPoint + "transport-order-margin-estimasi/create";
      this.$http
        .post(baseURI, payload)
        .then((response) => {
          this.isLoading = false;
          if (response.data.status === 200) {
            this.success_box(response.data.datas.messages);

            //this.$router.push("/master-margin-estimasi");
          } else {
            this.errors = response.data.errors || {};
            this.resultError(this.errors);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                //this.resultError(error.response.data.errors);

                this.error_box(error.response.data.errors.messages);
              } else if (error.response.status === 500) {
                this.error(error.response.data.errors.message);
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    backForm() {
      this.$router.push("/master-margin-estimasi");
    },

    resultError(data) {
      Object.keys(data || {}).forEach((key) => {
        const messages = Array.isArray(data[key]) ? data[key] : [data[key]];
        messages.forEach((message) => this.error(message));
      });
    },


    success_box(messages) {
      const htmlContent = `
      
          <p><strong>Attention:</strong> ${messages.attention}</p>
          <p><strong>Count Add Margin List:</strong> ${messages.count_margin_estimasi}</p>
          <p><strong>Count Margin Estimasi Duplicate:</strong> ${messages.count_margin_estimasi_duplicated}</p>
          <p><strong>Count Margin Estimasi Success:</strong> ${messages.count_margin_estimasi_success}</p>
        
      `;

      this.$swal({
        icon: 'success',
        backdrop: true,
        title: "Success",
        html: htmlContent,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then((result) => {
        if (result.value) {
          window.location.href = "/master-margin-estimasi?status=200&msg=Successfully";
          //console.log(formData);
        }
      });


    },


    error_box(messages) {
      console.log(messages);
      let htmlContent = '';

      if (Array.isArray(messages)) {
        htmlContent = messages.map(message => `<p>${message}</p>`).join('');
      } else {
        htmlContent = `
           <p><strong>Attention:</strong> ${messages.attention}</p>
          <p><strong>Count Add Margin List:</strong> ${messages.count_margin_estimasi}</p>
          <p><strong>Count Margin Estimasi Duplicate:</strong> ${messages.count_margin_estimasi_duplicated}</p>
          <p><strong>Count Margin Estimasi Success:</strong> ${messages.count_margin_estimasi_success}</p>
        
        `;
      }

      this.$swal({
        icon: 'error',
        backdrop: true,
        title: "Error",
        html: htmlContent,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })


    },

    handleHttpError(error) {
      if (!error.response) {
        this.error("Terjadi kesalahan pada koneksi.");
        return;
      }

      if (error.response.status === 422) {
        this.errors = error.response.data.errors || {};
        this.resultError(this.errors);
      } else if (error.response.status === 500) {
        this.$router.push("/server-error");
      } else if (error.response.status === 401) {
        this.$router.push("/authorized-error");
      } else {
        this.$router.push("/page-not-found");
      }
    },

    success(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      Toast.fire({ icon: "success", title: message });
    },

    error(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
      });
      Toast.fire({ icon: "error", title: message });
    },
  },
};
</script>
